
/* Page « Formule étudiante » : la page sait l'heure (formule servie ou non, colonne du jour), le plateau se remplit,
   la carte étudiante « bipe », le ticket revient à la fin. */
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function q(s, r){ return (r || document).querySelector(s); }
  function qa(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }
  function onView(el, fn, opt){
    if (!el) return;
    if (!('IntersectionObserver' in window)){ fn(); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ io.disconnect(); fn(); } }); }, opt || {threshold: .35});
    io.observe(el);
  }

  /* ---- L'heure de Paris : jour de la semaine (1 = lundi … 7 = dimanche) et minutes ---- */
  var fmt = null;
  try { fmt = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Paris', weekday:'short', hour:'2-digit', minute:'2-digit', hourCycle:'h23'}); } catch(e){}
  var WD = {Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6, Sun:7};
  function paris(){
    var now = new Date();
    if (fmt){ var p = {}; fmt.formatToParts(now).forEach(function(x){ p[x.type] = x.value; }); return {d: WD[p.weekday] || 1, t: +p.hour * 60 + +p.minute}; }
    return {d: now.getDay() || 7, t: now.getHours() * 60 + now.getMinutes()};
  }
  var OPEN = 690, CLOSE = 840;   // 11h30 – 14h
  function formule(){
    var p = paris(), wk = p.d <= 5;
    if (wk && p.t >= OPEN && p.t < CLOSE) return CLOSE - p.t <= 30 ? {c:'soon', txt:'Dernière demi-heure · jusqu’à 14h'} : {c:'open', txt:'Servie maintenant · jusqu’à 14h'};
    if (wk && p.t < OPEN) return OPEN - p.t <= 30 ? {c:'soon', txt:'Bientôt servie · dès 11h30'} : {c:'soon', txt:'Servie aujourd’hui · dès 11h30'};
    if (p.d <= 4) return {c:'closed', txt:'Revient demain · 11h30'};
    return {c:'closed', txt:'Revient lundi · 11h30'};
  }
  function paintFormule(){
    var s = formule();
    qa('[data-formule]').forEach(function(el){
      el.classList.remove('open', 'soon', 'closed'); el.classList.add(s.c);
      var sp = q('span', el); if (sp && sp.textContent !== s.txt) sp.textContent = s.txt;
    });
  }
  paintFormule(); setInterval(paintFormule, 30000);

  /* ---- 2. Le plateau se remplit : deux Burger Jr, une frite, une boisson ---- */
  var compo = q('[data-compo]');
  if (compo && !reduce){ compo.classList.add('js'); onView(q('.tr-board', compo), function(){ compo.classList.add('in'); }, {threshold: .45}); }

  /* ---- 3. La carte étudiante « bipe » ---- */
  var reader = q('[data-reader]');
  if (reader && !reduce){
    reader.classList.add('js');
    var play = function(){
      reader.classList.remove('play', 'done'); void reader.offsetWidth; reader.classList.add('play');
      clearTimeout(reader._t); reader._t = setTimeout(function(){ reader.classList.add('done'); }, 720);
    };
    onView(reader, play, {threshold: .6});
    reader.addEventListener('click', play);
    reader.addEventListener('mouseenter', function(){ if (reader.classList.contains('done')) play(); });
  }

  /* ---- 4. L'emploi du temps vivant : la colonne du jour, le week-end ---- */
  var edt = q('[data-edt]');
  if (edt){
    var paintEdt = function(){
      var p = paris(), day = p.d <= 5 ? p.d - 1 : 0, we = p.d > 5;
      qa('[data-d]', edt).forEach(function(c){ c.classList.toggle('today', +c.getAttribute('data-d') === day); });
      var lab = q('[data-edt-today]', edt);
      if (lab) lab.textContent = we ? 'Ce week-end' : ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi'][day] + ' : c’est aujourd’hui';
      var w = q('[data-edt-we]', edt); if (w) w.hidden = !we;
    };
    paintEdt(); setInterval(paintEdt, 60000);
    if (!reduce){ edt.classList.add('js'); onView(edt, function(){ edt.classList.add('in'); }, {threshold: .4}); }
  }

  /* ---- 7. Fin : le ticket revient du coin ---- */
  var end = q('[data-end]');
  if (end){ end.classList.add('js'); onView(end, function(){ end.classList.add('in'); }, {threshold: .25}); }
})();

